import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

export interface ITestStep {
  order: number;
  title: string;
  description: string;
  result: ITestStepResult;
  isProcessing: boolean;
  hasFailed: boolean;
  hasCompleted: boolean;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string; };
  function?: () => Promise<ITestStepResult>;
}

export interface ITestStepResult {
  description: string;
}

export interface ITestResult {
  description: string;
  items: string[];
  info: ITestResultInfo[];
  isError: boolean;
}

export interface ITestResultInfo {
  result: string;
  hasError: boolean;
  errorMessage?: string;
  stackTrace?: string;
  suggestions?: ISuggestion[];
}

export const getEmptyTestResult = (): ITestResult => {
  const res = {
    description: '',
    isError: false,
    items: [],
    info: [],
  };
  return res;
};

export interface ISuggestion {
  key: string;
  suggestion: string;
  type: SuggestionType;
}

export enum SuggestionType {
  info,
  instruction,
  error,
  success,
}